import {ProcessStatus} from "../entity/ProcessStatus";
import {ProfileState} from "../entity/state/ProfileState";

export const initialProfileState: ProfileState = {
    updateMeStatus: ProcessStatus.None
};